import React from "react";
import AuthorityPage from "@/components/AuthorityPage";
import { WHY_TRUST } from "@/lib/authorityContent";

export default function WhyTrustUs() {
  return <AuthorityPage {...WHY_TRUST} pageType="AboutPage" testid="why-trust-page" />;
}
